/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Auth_TokenInputs */

const en_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication Token`)
};

const fr_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeton d'authentification`)
};

const de_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierungstoken`)
};

const it_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token di autenticazione`)
};

const ru_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Токен аутентификации`)
};

const es_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token de autenticación`)
};

const zh_cn2_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份验证令牌`)
};

const ja_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証トークン`)
};

const hi_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रमाणीकरण टोकन`)
};

const pt_pt2_options_integrations_auth_token = /** @type {(inputs: Options_Integrations_Auth_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token de autenticação`)
};

/**
* | output |
* | --- |
* | "Authentication Token" |
*
* @param {Options_Integrations_Auth_TokenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_auth_token = /** @type {((inputs?: Options_Integrations_Auth_TokenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Auth_TokenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_integrations_auth_token(inputs)
	if (locale === "de") return de_options_integrations_auth_token(inputs)
	if (locale === "it") return it_options_integrations_auth_token(inputs)
	if (locale === "ru") return ru_options_integrations_auth_token(inputs)
	if (locale === "es") return es_options_integrations_auth_token(inputs)
	if (locale === "zh-CN") return zh_cn2_options_integrations_auth_token(inputs)
	if (locale === "ja") return ja_options_integrations_auth_token(inputs)
	if (locale === "hi") return hi_options_integrations_auth_token(inputs)
	if (locale === "pt-PT") return pt_pt2_options_integrations_auth_token(inputs)
	return en_options_integrations_auth_token(inputs)
});